import * as React from "react";
import AppointmentDateTimeContainer from "../../../../../../../../../components/AppointmentDateTime/v3/components/AppointmentDateTime/AppointmentDateTimeContainer.js";
import { getBookAppointmentStore } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-store-by-id.js";
import { getBookAppointmentType } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-type.js";
import { MissingStoreIdError, AlternativeUrlStoreError, MissingTypeIdError, InvalidVirtualAppointmentError, StoreNotFoundError, TypeNotFoundError, TypeNotAvailableForStoreError, LinkedAppointmentTypeNotValidError, AlternativeLinkedAppointmentTypeNotValidError } from "../../../../../../../v3/pages/BookAppointment/errors.js";
import { getFormattedParams, hasValidVirtualAppointmentParams, generateVirtualAppointmentStoreByIdData, hasInvalidVirtualAppointmentParams, isAppointmentTypeValid } from "../../../../../../../v3/pages/BookAppointment/utils.js";
const WhenRoot = () => {
  return /* @__PURE__ */ React.createElement(AppointmentDateTimeContainer, null);
};
WhenRoot.getServerSideProps = async (apolloClient, params, locale) => {
  const formattedParams = getFormattedParams(params);
  if (formattedParams.globalStoreId === void 0) {
    throw MissingStoreIdError();
  }
  if (formattedParams.alternativeUrlStores?.includes(formattedParams.globalStoreId)) {
    throw AlternativeUrlStoreError();
  }
  if (formattedParams.typeId === void 0) {
    throw MissingTypeIdError();
  }
  let promises = [null, null];
  if (hasValidVirtualAppointmentParams(formattedParams)) {
    const type2 = await getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
    promises = [
      type2 ? generateVirtualAppointmentStoreByIdData(formattedParams.virtualStoreCode, type2) : null,
      // TODO: MACC-19077 formattedParams.virtualStoreCode is always a string. Remove as string before merging to master.
      type2
    ];
  } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
    throw InvalidVirtualAppointmentError();
  } else {
    promises = [
      getBookAppointmentStore(
        apolloClient,
        formattedParams.globalStoreId,
        locale,
        formattedParams.tryInStoreFlow,
        formattedParams.groupId
      ),
      getBookAppointmentType(apolloClient, formattedParams.typeId, locale)
    ];
  }
  const [store, type] = await Promise.all(promises);
  if (!store) {
    throw StoreNotFoundError();
  } else if (!type) {
    throw TypeNotFoundError();
  } else if (type && !isAppointmentTypeValid({
    typeId: type?.id,
    store
  })) {
    throw TypeNotAvailableForStoreError();
  } else if (formattedParams?.linkedAppointmentTypeId && !isAppointmentTypeValid({
    typeId: formattedParams?.linkedAppointmentTypeId,
    store
  })) {
    throw LinkedAppointmentTypeNotValidError();
  } else if (formattedParams?.alternativeLinkedAppointmentTypeId && !isAppointmentTypeValid({
    typeId: formattedParams?.alternativeLinkedAppointmentTypeId,
    store
  })) {
    throw AlternativeLinkedAppointmentTypeNotValidError();
  }
  let timeSlot = null;
  if (formattedParams.start && formattedParams.end) {
    timeSlot = {
      from: formattedParams.start,
      until: formattedParams.end
    };
  }
  return Promise.resolve({
    store,
    type,
    timeSlot
  });
};
export {
  WhenRoot as default
};
//# sourceMappingURL=WhenRoot.js.map
